<template>
  <div class="app-search-date">
    <span v-if="label" class="app-search-label">{{label}}：</span>

    <div v-if="isArrType">
      <el-select
        v-model="dateType"
        clearable
        size="small"
        placeholder="选择日期类型"
        style="margin-left: 1em;"
      >
        <el-option
          v-for="(type,index) in type"
          :key="index"
          :label="type.name"
          :value="type.type"
        />
      </el-select>
      <el-date-picker
        v-model="dateValue"
        style="width: 350px;margin-left:1em;"
        type="daterange"
        range-separator="-"
        size="small"
        start-placeholder="选择日期"
        end-placeholder="选择日期"
        value-format="yyyy-MM-dd"/>
    </div>

    <div v-else>
      <span v-show="classDate">选择上课日期:</span>
      <el-date-picker
        v-model="timeValue"
        style="width: 350px;margin-left:1em;"
        type="daterange"
        range-separator="-"
        size="small"
        start-placeholder="选择日期"
        end-placeholder="选择日期"
        value-format="yyyy-MM-dd"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSearchDate',

  props: {
    value: {
      type: String,
      default: '',
    },
    dateTypeDef: {
      type: String,
      default: '',
    },

    type: {
      type: [Array, String],
      default: () => ([]),
    },
    classDate: {
      type: Boolean,
      default: false,
    },
    time: {
      type: String,
      default: '',
    },
    timeBetween: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dateType: '',

      dateValue: [],

      timeValue: [],

      timeType: `between[${this.type}][]`,
    };
  },

  computed: {
    isArrType() {
      return this.type instanceof Array;
    },
  },


  watch: {
    dateType(value) {
      this.getUrl(value, this.dateValue);
    },

    dateValue(value) {
      this.getUrl(this.dateType, value);
    },

    timeValue(value) {
      if (!value) {
        this.$emit('input', '');
        return;
      }

      const dates = value.join(`&${this.dateTypeDef === 'search' ? 'search_time_start' : this.timeType}=`);
      const datesTime = `${value.join(` 00:00:00&${this.dateTypeDef === 'search' ? 'search_time_end' : this.timeType}=`)} 23:59:59`;
      const finalDates = this.time && this.time === 'datetimerange' ? dates : datesTime;

      this.$emit('input', `${this.dateTypeDef === 'search' ? 'search_time_start' : this.timeType}:${finalDates}`);
    },
  },

  created() {
    this.getStatusDate();
    this.timeType = `between[${this.timeBetween}${this.type}][]`;
  },

  methods: {
    getStatusDate() {
      const { page, per_page, ...search } = this.$route.query;

      const keyList = Object.keys(search);

      if (keyList.length === 0) return;

      if (this.timeType in search) {
        const data = search[this.timeType];

        this.timeValue = data.split(`&${this.timeType}=`);

        return;
      }

      const data = keyList.find((item) => {
        const betweenExist = item.indexOf('between') !== -1;

        const betweenCreated = item.indexOf('between[created_at]') === -1;

        return betweenExist && betweenCreated;
      });

      if (data !== undefined) {
        this.dateValue = search[data].split(`&${data}=`);

        this.dateType = data.slice(8, -3);
      }
    },

    getUrl(key, value) {
      if (!key) {
        this.$emit('input', '');
        return;
      }

      if (!value || value.length === 0) {
        this.$emit('input', '');
        return;
      }

      const keys = `between[${key}][]`;
      const dates = value.join(`&${keys}=`);
      console.log(`${keys}:${dates}`)

      this.$emit('input', `${keys}:${dates}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-search-date {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/AppSearch/AppSearchDate.vue